import { memo, useEffect } from 'react';
import { useSelector } from '@bonanza-social/toolkit/state';
import { BottomSheetExtendedProps } from '@bonanza-social/navigation';
import {
  selectRemainingSpinsCount,
  selectRemainingSpinsCountState,
} from '../state';
import InstantWheel from '../components/InstantWheel/InstantWheel';

function InstantWheelBottomSheet({ close }: BottomSheetExtendedProps) {
  const spinsCount = useSelector(selectRemainingSpinsCount);
  const spinsCountState = useSelector(selectRemainingSpinsCountState);

  useEffect(() => {
    if (!spinsCount && spinsCountState !== 'pending') {
      close();
    }
  }, [spinsCount, spinsCountState, close]);

  return <InstantWheel />;
}

export default memo(InstantWheelBottomSheet);
